// Agrupa por data_referencia (date puro, "2026-08-24") e ordena do mais
// recente pro mais antigo — usado no painel admin (NovidadesTiView) e no feed
// que o staff vê (NovidadesTiModal). Esse último agrupava por rótulo relativo
// (Hoje/Ontem/Esta semana/Mais antigo, ver agruparPorDataRelativa.ts,
// removido) — trocado por data explícita a pedido do usuário, pra não deixar
// ambíguo quando o item realmente aconteceu.

export function agruparPorData<T extends { data_referencia: string }>(itens: T[]): Array<[string, T[]]> {
    const mapa = new Map<string, T[]>();
    itens.forEach((item) => {
        if (!mapa.has(item.data_referencia)) mapa.set(item.data_referencia, []);
        mapa.get(item.data_referencia)!.push(item);
    });
    return Array.from(mapa.entries()).sort((a, b) => b[0].localeCompare(a[0]));
}

// timeZone: 'UTC' é obrigatório aqui: data_referencia é um `date` puro
// ("2026-08-24", sem hora), e o spec do JS interpreta string date-only como
// meia-noite UTC — sem fixar UTC no formatador, o navegador em Brasília
// (UTC-3) exibe o dia anterior (bug real que já aconteceu nesse mesmo campo,
// ver NovidadesTiView.tsx).
export function dataReferenciaBr(dataReferencia: string): string {
    return new Date(dataReferencia).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' });
}
